import { Marquee } from "../../ui/marquee";
import clsx from "clsx";
import { cn } from "../../../lib/utils";

interface IMarquee {
  className?: string;
  hideSecond?: boolean;
}

const HomeMarquee = ({ className, hideSecond }: IMarquee) => {
  const marqueeImages = [
    "/home/marquee/marquee-1.png",
    "/home/marquee/marquee-2.png",
    "/home/marquee/marquee-3.png",
    "/home/marquee/marquee-4.png",
    "/home/marquee/marquee-5.png",
    "/home/marquee/marquee-6.png",
    "/home/marquee/marquee-7.png",
    "/home/marquee/marquee-8.png",
    "/home/marquee/marquee-9.png",
  ];

  return (
    <div className="[--duration:20s]">
      <div className="grid w-full gap-5 bg-transparent">
        <Marquee
          pauseOnHover
          className="flex gap-2 justify-between [--duration:20s]"
        >
          {marqueeImages.slice(0, 5).map((image) => {
            return (
              <img
                key={image}
                src={image}
                alt=""
                className={cn("h-56 xl:h-[14rem] w-full", className)}
              />
            );
          })}
        </Marquee>
        <Marquee
          pauseOnHover
          reverse
          className={clsx("flex gap-2 justify-between [--duration:20s]", {
            hidden: hideSecond,
          })}
        >
          {marqueeImages.slice(5).map((image) => {
            return (
              <img
                key={image}
                src={image}
                alt=""
                className={cn("h-56 xl:h-[14rem]", className)}
              />
            );
          })}
        </Marquee>
      </div>
    </div>
  );
};

export default HomeMarquee;
